import React from 'react';
import { useSelector } from 'react-redux';
import FormSelect from 'shared/forms/FormSelect';
import { getChassisPools } from '../../../slices/chassisPools';

const ChassisPoolsMembersDropdown = ({data, ...props}) => {
  return (
    <FormSelect
      data={data}
      textField="label"
      dataItemKey="value"
      {...props}
    />
  );
}

export default ChassisPoolsMembersDropdown;